import React from 'react'
import CargoWiseSettings from './CargoWiseSettings'
import { useIntegrations } from '@wove/api'

interface IntegrationSettingsProps {
  integrationId: string
}

export default function IntegrationSettings({ integrationId }: IntegrationSettingsProps) {
  const { integrations, isLoading } = useIntegrations()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span className="ml-3 text-gray-600">Loading integration settings...</span>
      </div>
    )
  }


  const integration = integrations.find(i => i.id === integrationId)
  
  if (!integration) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
        <p className="text-yellow-800">Integration not found</p>
      </div>
    )
  }

  // Render different settings components based on integration source
  switch (integration.integrationSource) {
    case 'cw':
      return <CargoWiseSettings integrationId={integrationId} />
    default:
      return (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
          <p className="text-gray-600">
            Settings are not yet available for {integration.integrationSource} integrations.
          </p>
        </div>
      )
  }
}